import { api } from '../../shared/api/client';

export interface PartnershipInput {
  fullName: string;
  clinic: string;
  city: string;
  phone: string;
  email: string;
  comment: string;
}

export interface PartnershipRequest extends PartnershipInput {
  id: string;
  createdAt: string;
}

/** Заявка «Сотрудничество» из письма со снимками (без авторизации). */
export async function submitPartnership(body: PartnershipInput): Promise<void> {
  await api.post('/v1/public/partnership', body);
}

export async function listPartnershipRequests(): Promise<{
  items: PartnershipRequest[];
  total: number;
}> {
  const { data } = await api.get<{ items: PartnershipRequest[]; total: number }>(
    '/v1/admin/partnership-requests',
    { params: { limit: 200 } },
  );
  return data;
}
